import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { ESetLkTypeActionType, TLkType } from './types';
import { EUserLkType } from '../../../types/user';

export const setLkType: (lkType: EUserLkType) => TLkType = actionGenerator<ESetLkTypeActionType.Set, EUserLkType>(
  ESetLkTypeActionType.Set,
);
